module.exports = __webpack_public_path__ + "0a7003fbf6b2b1359cc0f614ae16e68d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/images/emmastone.jpg
// module id = 138
// module chunks = 0